import React, { useState } from "react";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";

import LoadingButton from "../../components/loadingButton";
import api from "../../services/api";

export default ({ location }) => {
  const [values, setValues] = useState({
    email: (location.state && location.state.email) || "",
    code: "",
    password: "",
  });

  const history = useHistory();

  const send = async () => {
    try {
      await api.post("/users/resetpassword", values);
      toast.success("Mot de passe modifié");
      history.push("/auth");
    } catch (e) {
      if (e && e.error === "WRONG_CODE") {
        toast.error("Code invalide ou expiré : demandez un nouveau code");
        return history.push("/auth/forgot");
      }
      if (e && e.code === "PASSWORD_NOT_VALIDATED")
        return toast.error(
          "Mot de passe invalide : minimum 6 caractères, au moins une lettre",
        );
      toast.error("Impossible de modifier le mot de passe");
    }
  };

  return (
    <div className="relative">
      <div className="mb-10 max-w-7xl mx-auto p-4">
        {/* <img src={logoImg} /> */}
      </div>

      <div className="flex items-center justify-center flex-col max-w-lg mx-auto w-full">
        <div className="font-[Helvetica] text-center text-[32px] font-semibold	mb-[15px]">
          Créer un nouveau mot de passe
        </div>
        <div>
          <div>
            <div className="mb-[25px] mt-4">
              <label htmlFor="email">Adresse e-mail</label>
              <input
                className="w-full mt-1"
                name="email"
                type="email"
                id="email"
                value={values.email}
                onChange={(e) =>
                  setValues({ ...values, email: e.target.value })
                }
              />
            </div>
            <div className="mb-[25px]">
              <label htmlFor="code">Code reçu par e-mail</label>
              <input
                className="w-full mt-1"
                name="code"
                type="text"
                inputMode="numeric"
                id="code"
                value={values.code}
                onChange={(e) => setValues({ ...values, code: e.target.value })}
              />
            </div>
            <div className="border-[1px] border-gray-200 bg-gray-50 text-gray-500 p-2 rounded-md italic">
              Format : minimum 6 caractères, au moins une lettre
            </div>
            <div className="mb-[25px] mt-4">
              <label htmlFor="password">Nouveau mot de passe</label>
              <input
                className="w-full mt-1"
                name="password"
                type="password"
                id="password"
                value={values.password}
                onChange={(e) =>
                  setValues({ ...values, password: e.target.value })
                }
              />
            </div>
            <LoadingButton
              className="py-3.5 w-full text-center bg-app text-white rounded-lg mt-5"
              onClick={send}
            >
              Créer
            </LoadingButton>
          </div>
        </div>
      </div>
    </div>
  );
};
